<ng-template [ngIf]="isApprovandoInvioInfratel">
  <app-loading></app-loading>
</ng-template>
<div class="d-flex mt-1 ">
  <form [formGroup]="approvaInvioInfratelForm">
    <div class="grid formgrid p-fluid ">
      <div class="field" [ngClass]="{'col-4': fase === 1, 'col-6': fase !== 1}">
        <label for="dataInvio" >Data invio ad INFRATEL</label>
        <p-calendar
            formControlName="dataInvio"
            id="dataInvio"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            placeholder="Data invio"
            [appendTo]="'body'"
          ></p-calendar>
      </div>
      <div class="field" [ngClass]="{'col-4': fase === 1, 'col-6': fase !== 1}">
        <label for="dataRicevimento" >Data ricevimento risposta</label>
        <p-calendar
          formControlName="dataRicevimento"
          id="dataRicevimento"
          [showIcon]="true"
          dateFormat="dd/mm/yy"
          placeholder="Data ricevimento"
          (onSelect)="onDataRicevimentoSelect($event)"
          [appendTo]="'body'"
        ></p-calendar>
      </div>
      <div class="field col-4" *ngIf="fase===1">
        <label for="dataPecODE" >Data {{labelData}}</label>
        <p-calendar
          formControlName="dataPecODE"
          id="dataPecODE"
          [showIcon]="true"
          dateFormat="dd/mm/yy"
          placeholder="Data {{labelData}}"
          [appendTo]="'body'"
        ></p-calendar>
      </div>
  </div>
</form>
</div>
  <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isApprovandoInvioInfratel || !approvaInvioInfratelForm.valid"></p-button>
</div>
<p-toast />
<p-confirmDialog /> 